import {Component, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {filter, map, switchMap, take} from 'rxjs/operators';
import {LaunchDarklyFlag, LaunchDarklyService} from '@aiwyn/config';
import {AuthService, GuestUser} from '@aiwyn/auth';
import {ROUTE_TOKEN_LOGIN, ROUTE_TOKEN_MAIN_BASE} from '../../../routing-constants';
import {Observable, of} from 'rxjs';
import {LoadableHelper, LoadableStatus} from '@aiwyn/shared';

@Injectable({
  providedIn: 'root',
})
export class RegistrationGuard implements CanActivate {

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly launchDarklyService: LaunchDarklyService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.launchDarklyService.getFeatureFlag(LaunchDarklyFlag.ENABLE_PASSWORDLESS_LOGIN).pipe(
      switchMap(passwordlessLoginEnabled => this.authService.getAuthProviderUser().pipe(
        filter(({ status }) => LoadableHelper.isLoaded(status, true)),
        take(1),
        switchMap(({ status, data: user }) => {
          if (!user || status === LoadableStatus.ERROR) {
            if (passwordlessLoginEnabled) {
              return of(this.router.createUrlTree([ROUTE_TOKEN_LOGIN]));
            }

            return of(true);
          }

          return this.authService.getUserLoadable().pipe(
            filter(({ status }) => LoadableHelper.isLoaded(status, true)),
            switchMap(({ status: appStatus, data: appUser }) => {
              if (appStatus === LoadableStatus.ERROR || !appUser) {
                return this.authService.signOut(false).pipe(
                  map(_ => this.router.createUrlTree(['register'])),
                );
              }

              return appUser instanceof GuestUser ? of(true) : of(this.router.createUrlTree([ROUTE_TOKEN_MAIN_BASE]));
            }),
          )
        })
      ))
    );
  }
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: false,
})
export class RegisterComponent  { }
